/** @jsx jsx */
import { jsx } from '@emotion/react'
import { Link } from 'react-router-dom'

import { ReactComponent as PageNotFoundImage } from '../../images/PageNotFoundImage.svg'
import { PrimaryButton } from '../../buttons'
import { H1 } from '../../elements'
import { errorCss, descriptionCss, linkCss } from '../errorCss'

type PageNotFoundProps = {
  /** Whether the user is currently authenticated, from useAuth0 */
  isAuthenticated: boolean
}

const PageNotFoundError = ({ isAuthenticated }: PageNotFoundProps) => (
  <div css={errorCss}>
    <PageNotFoundImage />
    <H1>Page not found</H1>
    <p css={descriptionCss}>
      The page your are looking for does not exist. Please check the URL and try again.
    </p>
    {isAuthenticated && (
      <Link css={linkCss} to="/">
        <PrimaryButton>Go Home</PrimaryButton>
      </Link>
    )}
  </div>
)

export default PageNotFoundError
